export const gridWidth = {
  '1': '1fr',
  '2': '20rem',
  '3': '20rem',
  '4': '15rem',
  '5': '12.5rem',
  '6': '10rem',
};
